export const CurrencyItems = {
    UAH: '\u20B4 UAH',
    USD: '\u0024 USD',
    EURO: '\u20AC EURO',
} as const;
